module.exports = __webpack_public_path__ + "static/media/straw_mulcher_blower.c3ce80f7.svg";